import Vue from 'vue';
// 设置数据
import * as types from './mutations-types'

const mutations = {
  [types.SET_RANK] (state, data) {
    state.list = data
  },
  [types.SET_URL_INFO] (state, data) {
    state.urlInfo = data
  },
  [types.SET_PROJECT_INFO] (state, data) {
    state.projectInfo = data
  },
  [types.SET_FILE_INFO] (state, data) {
    state.fileInfo = data
  },
  [types.SET_FILE_TASK_INFO] (state, data) {
    state.fileTsakInfo = data
  },
  [types.SET_TASK_PROGRESS] (state, data) {
    state.taskProgress = data
  },
  [types.SET_TASK_CONTENT] (state, data) {
    state.taskContentList = data
  },
  [types.SET_CURRENT_SENTENCE_ID] (state, data) {
    state.currentSentenceId = data
  },
  //右键定位信息
  [types.SET_RIGHT_MOUSE_POSITION] (state, data) {
    state.position = data
  },
  //操作栏目点击标志-右侧展示内容控制
  [types.SET_OPERATION_SIGN] (state, data) {
    if (
      state.editorRightShown.column === 'second' &&
      data.column === 'second' &&
      data.hasOwnProperty('sourceKeyword') &&
      data.hasOwnProperty('targetKeyword')
    ) {
      if (data.sourceKeyword !== null && data.sourceKeyword !== undefined && data.sourceKeyword !== '') {
         // 如果 sourceKeyword 属性不存在，则创建它
      if (!state.editorRightShown.hasOwnProperty('sourceKeyword')) {
        Vue.set(state.editorRightShown, 'sourceKeyword', '');
      }
      state.editorRightShown.sourceKeyword = data.sourceKeyword;
      }
      if (data.targetKeyword !== null && data.targetKeyword !== undefined && data.targetKeyword !== '') {
             // 如果 targetKeyword 属性不存在，则创建它
      if (!state.editorRightShown.hasOwnProperty('targetKeyword')) {
        Vue.set(state.editorRightShown, 'targetKeyword', '');
      }
      state.editorRightShown.targetKeyword = data.targetKeyword;
      }
      //清空
      if(data.sourceKeyword == ''&& data.targetKeyword == ''){
        state.editorRightShown = data;
      }
    } else {
      state.editorRightShown = data;
    }
  },
  [types.SET_SUGGEST_REMARKS_STATE] (state, data) {
    state.suggestRemarks = data
  },
  [types.SET_FILE_PREVIEW_CONTENT] (state, data) {
    state.filePreviewContent = data
  },
  [types.SET_EDITOR_BOTTOM_ACTIVE_NAME] (state, data) {
    state.editorBottomActiveName = data
  },
  [types.SET_TASK_QACHECK_INFO] (state, data) {
    state.QAList = data
  },
  [types.SET_FRAGMENT_QACHECK_INFO] (state, data) {
    state.fragmentQAInfo = data
  },
  [types.SET_EDITOR_PATTERN_INFO] (state, data) {
    state.editorMode = data
  },
  [types.SET_FONT_SIZE_INFO] (state, data) {
    state.editorFontSize = data
  },
  [types.SET_THEME_INFO] (state, data) {
    state.themeInfo = data
  },
  [types.SET_SEARCH_INFO] (state, data) {
    state.searchInfo = data
  },
  [types.SET_MODIFY_RECORD_INFO] (state, data) {
    state.modifyRecord = data
  },
  [types.SET_MODIFY_RECORD_PARAMS_INFO] (state, data) {
    state.modifyRecordParams = data
  },
  [types.SET_PREVIEW_PARAMS_INFO] (state, data) {
    state.previewParams = data
  },
  [types.SET_QA_STATE_INFO] (state, data) {
    state.QAState = data
  },
  [types.SET_TASK_CONTENT_PARAMS] (state, data) {
    console.log(data)
    state.taskContentListParams = data
  },
  [types.SET_FRAGMENT_TERM_INFO] (state, data) {
    state.fragmentTerm = data
  },
  [types.SET_FRAGMENT_MEMORY_INFO] (state, data) {
    state.fragmentMemory = data
  },
  [types.SET_CURRENT_REMARKS_INFO] (state, data) {
    state.currentRemarks = data
  },
  [types.SET_TRANSLATE_DICT_LIST_INFO] (state, data) {
    state.translateDictionary = data
  },
  [types.SET_TEMP_SENTENCE_ID_INFO] (state, data) {
    state.tempSentence = data
  },
  [types.SET_EDITOR_RIGHT_ACTIVE_NAME_INFO] (state, data) {
    state.suggestActiveName = data
  },
  [types.SET_HISTORY_RECOVER_DATA_INFO] (state, data) {
    state.revokeData = data
  },
  [types.SET_HISTORY_RECOVERY_DATA_INFO] (state, data) {
    state.recoveryData = data
  },
  [types.RECORD_CURSOR_POSITION_INFO] (state, data) {
    state.cursorPositionInfo = data
  },
  [types.RECORD_CURSOR_POSITION_TARGET_INFO] (state, data) {
    state.cursorPositionTargetInfo = data
  },
  [types.GET_MYMESSAGE_INFO] (state, data) {
    state.mymessageList = data
  },
  [types.GET_MESSAGE_STATUS] (state, data) {
    state.messagestatus = data
  },
  [types.SET_UPDATE_STATE_INFO] (state, data) {
    state.updata = data
  },
  [types.SET_LOADING_INFO] (state) {
    state.loading = true
  },
  [types.CANCEL_LOADING_INFO] (state) {
    state.loading = false
  },
  [types.SET_USER_INFO] (state, data) {
    state.userInfo = data
  },
  [types.SET_UPDATA_FRAGMENT_TYPE] (state, data) {
    state.updataFragmentType = data
  },
  [types.SET_TERM] (state, data) {
    state.taskContentList.transSentRespVoList = data
  },
  UPDATE_transSentRespVoList_ITEM (state, data) {
    console.log(data);
    // state.taskContentList.transSentRespVoList.forEach(item => {
    //   if(item.id == data.id){
    //     item = data
    //   }
    // });
  },
  [types.SET_SOURCEEDITOR_STATUS] (state, data) {
    state.sourceedit = data
  },
  [types.SET_TARGETEDITOR_STATUS] (state, data) {
    state.targetedit = data
  },
  [types.SET_ELE_STATUS] (state, data) {
    state.EleStatus = data
  },
  [types.SET_SOURCEEDITOR_ISSTATUS] (state, data) {
    state.isSourceedit = data
  },
  //原译文预览
  [types.SET_PREVIEW_INFO] (state, data) {
    state.setPreviewInfo = data
  },
  // 存贮原译文页数
  [types.SET_WORD_PREVIEW] (state, data) {
    state.wordPreview.partIndex = data
  },
  // 指定原译文 段落
  [types.SET_APPOINT_PREVIEW] (state, data) {
    state.setAppointPreview = data
  },
  // 失焦改变的句子
  [types.SET_SENT_COUNT_INFO] (state, data) {
    state.setSentCountInfo = data
  },
  [types.SET_THIRD] (state, data) {
    state.setthird = data
  },
  //设置编辑模式
  // [types.SET_COMPARISON_MODE](state, data) {
  //   state.comparisonMode = data
  // },
  // //对照数据
  // [types.SET_COMPARISON_LIST](state, data) {
  //   state.ComparisonList = data
  // },
  //设置theme 数据
  [types.SET_THEME_LIST] (state, data) {
    state.theme = data
  },
  // 设置 临时术语表
  [types.UPDATE_TEMPORARY_TERM_LIST] (state, data) {
    state.temporaryTermList = data
  },
  // 设置 导出选项
  [types.UPDATA_IMPORT_OPTION] (state, data) {
    state.importOption = data
  },
  // 设置 当前所在预览模式
  [types.UPDATE_CURRENT_VIEW_MODE] (state, data) {
    state.currentViewMode = data
  },
  // 评价结果
  [types.UPDATE_EVALUATION_RESULTS] (state, data) {
    state.evaluationResults = data
  },
  // 机翻结果
  [types.UPDATE_FRAGMENT_SENTENCE_MT] (state, data) {
    state.fragmentSentenceMt = data
  },
  //译文句子为空
  [types.GET_COUNTTARGET_SENTIS] (state, data) {
    state.countTargetIsnullIdList = data
  },
  //存储修改句子列表数据
  [types.SET_EDITORDATA_LIST] (state, payload) {
    const { params: data, operation } = payload
    if (operation === 'set') {
      state.editordataList.set(`${data.sentId}_${data.type}`, data)
    } else if (operation === 'clear') {
      state.editordataList.clear()
    }
  },
  //初始化编辑器数据
  INIT_EDITOR_STATE(state,payload){
    state.taskContentListParams= {
      row: 50,
      startSort: 1,
    }
    state.taskContentList = {}
    state.translateDictionary =[]
  }

};

export default mutations;
